
// Generic "lift the chat bubble above the sticky buy bar" logic.
// We don't control BestChat's (or any future chat app's) internal markup, so instead of
// hardcoding a selector that might break the moment they update their widget, this watches
// for any fixed-position element that lands in the bottom-right corner of the screen —
// which is where virtually every chat bubble app places itself — and applies the same
// scroll-based lift that our own floating-contact button already uses.
(function () {
  var LIFT_PX = 84; // matches the sticky bar's height + a small gap
  var CORNER_MARGIN = 140; // how close to the bottom-right corner counts as "a chat bubble"
  var trackedEls = [];

  function looksLikeCornerBubble(el) {
    if (el === document.getElementById('cph-sticky-bar')) return false;
    if (el.id === 'cart-drawer' || el.id === 'cart-drawer-overlay') return false;
    if (el.classList && el.classList.contains('floating-contact-btn')) return false;

    var style = window.getComputedStyle(el);
    if (style.position !== 'fixed') return false;

    var rect = el.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;

    var nearRight = (window.innerWidth - rect.right) < CORNER_MARGIN;
    var nearBottom = (window.innerHeight - rect.bottom) < CORNER_MARGIN;
    return nearRight && nearBottom;
  }

  function scanForBubbles(root) {
    var all = (root || document.body).querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (trackedEls.indexOf(el) !== -1) continue;
      if (looksLikeCornerBubble(el)) {
        el.setAttribute('data-cph-tracked-bubble', 'true');
        trackedEls.push(el);
      }
    }
  }

  function applyLift(isLifted) {
    trackedEls.forEach(function (el) {
      if (!el.isConnected) return;
      el.style.transition = el.style.transition || 'transform 0.25s ease';
      el.style.transform = isLifted ? 'translateY(-' + LIFT_PX + 'px)' : '';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scanForBubbles();

    // Apps often inject their widget a second or two after page load, so keep watching.
    var observer = new MutationObserver(function () { scanForBubbles(); });
    observer.observe(document.body, { childList: true, subtree: true });

    // Re-use the same trigger element our sticky bar uses, so both move in sync.
    var trigger = document.getElementById('cph-sticky-trigger');
    if (trigger && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
          applyLift(scrolledPast);
        });
      }, { threshold: 0 });
      io.observe(trigger);
    }
  });
})();
